module.exports = __webpack_public_path__ + "media/images/about/h_1-87e00d1c94d0f8be13819dce5db3294e.png";